import React, { useMemo, useState } from "react";
import { Task, Tasks } from "@/types/flows";
import type { Annotation } from "@/types/annotation";
import { useFrame } from "./FrameContext";
import { useModel } from "./ModelContext";
import { CoreAppContextType, CoreAppContext } from "./CoreAppContext";
import { useCurrentMedia } from "@/store";

export const CoreAppProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [task, setTask] = useState<Task>(Tasks.OBJECT_DETECTION);
    const currentMedia = useCurrentMedia();

    // frame + annotation contexts – used to compute the currently-selected object label
    const { selectedAnnotationId } = useFrame();
    const { annotationsForFile } = useModel();

    const selectedObject = useMemo(() => {
        if (!selectedAnnotationId) return null;
        if (!currentMedia?.frame?.id) return null;

        const currentAnnotations: Annotation[] = annotationsForFile[currentMedia?.frame?.id] || [];
        const selectedAnnotation = currentAnnotations.find(
            (anno) => anno.id === selectedAnnotationId
        );
        return selectedAnnotation?.label || null;
    }, [selectedAnnotationId, annotationsForFile, currentMedia?.frame?.id]);

    const [previouslySelectedObject, setPreviouslySelectedObject] = useState<string | null>(null);
    const [hideSidebar, setHideSidebar] = useState(false);
    const [showLabels, setShowLabels] = useState(true);
    const [showSliderHint, setShowSliderHint] = useState(false);
    // const [loading, setLoading] = useState(false);

    const contextValue = useMemo<CoreAppContextType>(
        () => ({
            task,
            selectedObject,
            previouslySelectedObject,
            hideSidebar,
            showLabels,
            showSliderHint,
            // loading,
            setTask,
            setPreviouslySelectedObject,
            setHideSidebar,
            setShowLabels,
            setShowSliderHint
            // setLoading
        }),
        [
            task,
            selectedObject,
            previouslySelectedObject,
            hideSidebar,
            showLabels,
            showSliderHint
            // loading,
        ]
    );

    return <CoreAppContext.Provider value={contextValue}>{children}</CoreAppContext.Provider>;
};
